import React from "react";
import SystemAPI from "../network/SystemAPI";
import InBetweenOverlay from "./InBetweenOverlay";
import Overlay from "./Overlay";

interface HomeState {
    logoURL:string
    productName:string
    buttonColorHexValue:string
    showLoading:boolean
}

class Home extends React.Component<{}, HomeState> {
    constructor(props) {
        super(props);
        this.state = {
            logoURL: '',
            productName: '',
            showLoading: false,
            buttonColorHexValue: '',
        };
    }

    componentDidMount(): void {
        document.title = 'Home';
        this.setState({showLoading: true},  async () => {

            // Match patient portal branding: solid Midnight background.
            document.body.style.backgroundColor = '#291B2B';
            document.body.style.backgroundImage = 'none';


            let currentURL = window.location.href;

            SystemAPI.getProductBrandingFromURL(currentURL).then(data => {
                this.setState({logoURL: data.ProductLogoURL, productName: data.Name, buttonColorHexValue: data.ProductButtonColorHexValue, showLoading: false});
            })
        })
        
    }

    render(): React.ReactElement | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return (<React.Fragment>
            <Overlay show_loading={this.state.showLoading} />
            {/* <InBetweenOverlay showInBetween={true} zIndex={-10}/> */}

            <div className={this.state.showLoading ? "d-none" : "container min-vh-100 d-flex flex-column justify-content-center"}>
            <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: '#291B2B', zIndex: -1, }}></div>
                <div className="row responsive-p">
                    <div className={"col-12 pb-4"}>
                        <h1 className={"text-center verlag-light"}>
                            <img src={this.state.logoURL}
                                className={"homepage-logo"}
                                alt={this.state.productName}/>
                        </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <p className="text-center text-light mt-3"></p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 d-flex justify-content-center mt-3">
                        <a href={"/login"} className={"btn btn-lg"} style={{backgroundColor: '#C9A8FB', color: '#291B2B', fontWeight: 600, borderRadius: 999, padding: '12px 28px'}}>

                                Log In

                        </a>
                        <a href={"/results"} className={"btn btn-lg ml-2"} style={{backgroundColor: 'transparent', color: '#C9A8FB', fontWeight: 600, borderRadius: 999, padding: '12px 28px', border: '1px solid rgba(201,168,251,0.33)'}}>

                                Results

                        </a>
                    </div>
                </div>
            </div>
            
        </React.Fragment>)
    }
}
export default Home;